import React from 'react';
import { makeStyles } from '@material-ui/core';
import Image from 'components/Image';
import { images } from 'utils/icons';

const style = makeStyles(() => ({
  image: {
    height: '50px',
    width: '50px',
    borderRadius: '50%',
    backgroundSize: 'cover',
  },

  evidenceItem: {
    paddingBottom: '1rem',
    textAlign: 'left',

    '& span': {
      display: 'block',
    },
  },
}));

export const DISPLAY_TYPE = {
  image: 'image',
  evidenceArray: 'evidence-array',
  string: 'string',
};

export const getRowValue = ({
  data,
  showMediaInPortal,
  handleDisplayImageInPortal,
}) => {
  const valueType = data && data.type;
  const classes = style();

  switch (valueType) {
    case 'image':
      return (
        <div
          className={classes.image}
          style={{ backgroundImage: `url(${data.value})` }}
          onClick={showMediaInPortal ? handleDisplayImageInPortal : null}
        />
      );
    case 'audio':
      return (
        <Image
          onClick={showMediaInPortal ? handleDisplayImageInPortal : null}
          src={images.playMedia.default}
        />
      );
    case 'evidence-array': {
      return (
        <div>
          {data.value.map(item => {
            return (
              <div key={item.id} className={classes.evidenceItem}>
                <span>{item.type.displayValue}</span>
                <span>
                  {item.description.displayValue || item.description.value}
                </span>
              </div>
            );
          })}
        </div>
      );
    }
    default:
      return data;
  }
};
